/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import { axios, fetchTemp } from '@/../utils';

export const namespaced = true;

const getDefaultState = () => {
    return {
        id: undefined,
        ownerId: window.ownerId,
        companyId: window.companyId,
        status: 'Incomplete',
        jobNumber: undefined,
        installationDate: undefined,
        name: undefined,
        email: undefined,
        phone: undefined,
        address: {
            formatted: undefined,
            lat: undefined,
            lng: undefined,
        },
        buildingType: undefined,
        nmi: undefined,
        meterNumber: undefined,
        noOfPhases: undefined,
        notes: undefined,
        consent: undefined,
        temperature: undefined,

        logoName: undefined,
        logoEncoded: undefined,

        role: 'Designer and Installer',
        additionalRole: undefined,
        additionalName: undefined,
        additionalNumber: undefined,
        cableDiagram: undefined,
        commissioningSheet: undefined,
        datasheet: undefined
    };
};

export const state = getDefaultState();

export const mutations = {
    SET_FIELD(state, payload) {
        state[payload.field] = payload.value;
    },

    POPULATE_STATE(state, payload) {
        Object.keys(payload).forEach((key) => {
            state[key] = payload[key]
        })
    },

    RESET_STATE(state) {
        Object.assign(state, getDefaultState());
    }
};

export const actions = {
    async updateField({ commit }, { field, value }) {
        commit('SET_FIELD', { field, value });

        if (field === 'address') {
            const { minTemp, maxTemp } = await fetchTemp({ lat: value.lat, lng: value.lng });
            commit('SET_FIELD', {
                field: 'temperature', value: { min: minTemp, max: maxTemp }
            });
        }
    },

    jobObject({ state, rootGetters }) {
        return {
            jobId: state.id,
            ownerId: state.ownerId,
            companyId: state.companyId,
            status: state.status,
            details: {
                jobNumber: state.jobNumber,
                installationDate: state.installationDate,
                name: state.name,
                email: state.email,
                phone: state.phone,
                address: state.address,
                buildingType: state.buildingType,
                nmi: state.nmi,
                meterNumber: state.meterNumber,
                noOfPhases: state.noOfPhases,
                notes: state.notes,
                consent: state.consent,
                temperature: state.temperature,
                logoName: state.logoName,
                logoEncoded: state.logoEncoded,
                role: state.role,
                additionalRole: state.additionalRole,
                additionalName: state.additionalName,
                additionalNumber: state.additionalNumber,
                cableDiagram: state.cableDiagram,
                commissioningSheet: state.commissioningSheet,
                datasheet: state.datasheet
            },
            configuration: rootGetters['configuration/formatted'],
            products: rootGetters['products/productIDs']
        }
    },

    async createJob({ dispatch }) {
        const data = await dispatch('jobObject');

        return axios.post('/account/job', {
            method: 'create',
            ...data
        }).then((response) => {
            return response.data;
        });
    },

    async updateJob({ dispatch }) {
        const data = await dispatch('jobObject');

        return axios.post('/account/job', {
            method: 'update',
            ...data
        }).then((response) => {
            return response.data;
        });
    },

    populateJob({ commit }, payload) {
        commit('POPULATE_STATE', payload)
    },

    resetState({ commit }) {
        commit('RESET_STATE');
    }
};
